import IconFurnitureHome from "~/assets/home-icons/iconFurnitureHome.svg"
import IconDeliveryHome from "~/assets/home-icons/iconDeliveryHome.svg"
import IconPriceHome from "~/assets/home-icons/iconPriceHome.svg"
import IconYearsHome from "~/assets/home-icons/iconYearsHome.svg"
import IconCustomerHome from "~/assets/home-icons/iconCustomerHome.svg"
import cookiesSVG from "../custom_icons/cookie.svg"
import IconBrandHome from "../assets/iconBrandHome.svg"

export const coverImage = "data:image/png;base64,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"

export const carouselHome = {
    items:
        [
            {
                src: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/bnre1.jpg?v=1748274215",
                h2: 'Custom Bedroom Available',
                p: 'Your choice of the type of Wood and the finish',
                a: 'Shop Now',
                url: '/collections/bedroom-furniture_12',
                showButton: true,
                imageUrl: "",
                logo: ""
            },
            {
                src: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/bnre2.jpg?v=1748274706",
                h2: 'Stanton Sofas available in many fabric options',
                p: 'We Have Great Variety',
                a: 'Shop Now',
                url: '/collections/stanton',
                showButton: true,
                imageUrl: "",
                logo: ""
            },
            {
                src: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/bnrep.jpg?v=1748275248",
                h2: 'Choose from a variety of Whittier Wood',
                p: 'We have an option for everyone',
                a: 'Shop Now',
                url: '/collections/whittier',
                showButton: true,
                imageUrl: "",
                logo: ""
            },
            {
                src: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/bnr1t.jpg?v=1748275863",
                h2: 'Choose style and comfort with Artisan Chairs',
                p: 'Comfort With Style',
                a: 'Shop Now',
                url: '/collections/artisan-chairs',
                showButton: true,
                imageUrl: "",
                logo: ""
            },
        ],
    interval: 8000
}

export const header = {
    activityBar: {
        show: true,
        span: "Welcome to Woodshed Furniture - ",
        p: "Decorate your home with us!",
        showActionButtons: false,
        socialButtons: false,
    },
    cartIcon: null,
    accountIcon: null,
    phoneIcon: null,
    cartCounter: true,
    logoDefault: false,
    logoStore: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/Woodshed_logo_1.png?v=1748273961",
    logoMobileDrawer: "",
    viewSticky: false,
    option: 1, // 0->empty 1->regular 2->custom 3->inline 4->kiosk 5->leftHeader
    showActionButton: true,
    hiddenBrand: false,//header type 4 kiosk TODO: setting shop
    searchInNavigation: false,
    hiddenProductRanges: false
}

export const featuredProducts = {
    title: "Featured Products",
    subtitle: "Featured Products description",
    visibility: true
}

export const quote = {
    enabled: false,
    email: "damy@retailsystem.com"
}

export const bigBannerBottom = {
    smallText: "Woodshed Furniture",
    title: "Quality Mattresses for everyone!",
    description: "Choose comfort for your best night's sleep",
    textButton: "Shop Now",
    href: "/collections/mattresses_2799",
    imageUrl: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/1ytbBiOtNz9bQFpU_SGjwiQmR9dOYr9z__s2048.jpg?v=1748276272"
}

export const smallBannerHome = {
    h3: "SYNCHRONY HOME CREDIT CARD",
    subtitle: "",
    href: "https://www.synchrony.com/financing/home/partners",
    textButton: "",
}

export const categoriesGridHome = {
    title: "",
    subtitle: "",
}

export const iconsHome = {
    h3: "Why Choose Us",
    items:
        [
            { title: "Wide Product Range", subtitle: "We offer a diverse selection of furniture to suit every taste and need", icon: IconBrandHome, href: "" },
            { title: "Customer Satisfaction", subtitle: "Reliable Furniture Supplier With Excellent Customer Service", icon: IconYearsHome, href: "" },
            { title: "Expert Advice & Support", subtitle: "Our team of experts is always on hand to offer guidance", icon: IconCustomerHome, href: "" },
        ]
}

export const justin =
{
    title: "Title just in",
    items:
        [
            {
                subtitle: "Subtitle just in ",
                from: 0,
                to: 30
            }
        ]
}

export const twoCollections = {
    title: " Explore our other favourite categories for more handpicked items",
    subtitle: "",
    leftCollection:
    {
        title: "Home Office",
        subtitle: "Many Options for your Home Office Needs",
        imageUrl: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/sdsdsfcs.jpg?v=1748277759",
        href: "/collections/home-office_1036",
        textButton: "Shop Now"
    },
    rightCollection:
    {
        title: "Recliners & Chairs",
        subtitle: "Comfortable Recliners in Your Choice of Cover",
        imageUrl: "https://cdn.shopify.com/s/files/1/0958/8008/5842/files/sdswwdd.jpg?v=1748277911",
        href: "/collections/recliners-chairs_687",
        textButton: "Shop Now"
    }
}

export const blogHome = {
    sectionTitle: "RECENT POST",
    textButton: "Read more",
    enabledContentHtml: true,
    route: "news" //nombre de la carpeta en routa,  routes/news/[handle].server.tsx
}

export const bigBannerTopSetting =
{
    image: "",
    subtitle: ""
}

export const attracBanner = {
    show: false,
    siteURL: 'https://websystem-cranleigh.myshopify.com/banner',
    appURL: 'https://assets.apphero.co/',
    code: 'class="aph_bars_app_embed"  value=',
}

export const googleReviewsPlaceId = "";

export const navigationWithoutHover = false;

export const cookieConsent = {
    enabled: true,
    message: "This website uses cookies to make sure you get the best experience with us.",
    icon: {
        show: true,
        url: cookiesSVG
    },
    privacyLink: "/page/privacy",
    privacyLinkText: "Learn more",
    agreeButtonText: "Got it!",
    denyButtonText: "Decline",
    revertButtonText: "Delete Cookie Consent"
}